var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-wrap":"nowrap","align-items":"center"}},[_vm._t("default",null,{"newDateGroup":_vm.newDateGroup,"updateFunc":_vm.debouncedSaveDate,"clearFunc":_vm.clearDateGroup})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }